/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Enumerates the options for how column hiding is animated.
 */
export var ColumnHidingAnimationMode = /*@__PURE__*/ (function (ColumnHidingAnimationMode) {
    /**
     * The correct animation mode is automatically selected.
     */
    ColumnHidingAnimationMode[ColumnHidingAnimationMode["Auto"] = 0] = "Auto";
    /**
     * No animation is performed.
     */
    ColumnHidingAnimationMode[ColumnHidingAnimationMode["None"] = 1] = "None";
    /**
     * The cells slide to the left.
     */
    ColumnHidingAnimationMode[ColumnHidingAnimationMode["SlideToLeft"] = 2] = "SlideToLeft";
    /**
     * The cells slide to the right.
     */
    ColumnHidingAnimationMode[ColumnHidingAnimationMode["SlideToRight"] = 3] = "SlideToRight";
    /**
     * The cells slide to the top.
     */
    ColumnHidingAnimationMode[ColumnHidingAnimationMode["SlideToTop"] = 4] = "SlideToTop";
    /**
     * The cells slide to the bottom.
     */
    ColumnHidingAnimationMode[ColumnHidingAnimationMode["SlideToBottom"] = 5] = "SlideToBottom";
    /**
     * The cells fade out.
     */
    ColumnHidingAnimationMode[ColumnHidingAnimationMode["FadeOut"] = 6] = "FadeOut";
    /**
     * The cells slide to the left and fade out.
     */
    ColumnHidingAnimationMode[ColumnHidingAnimationMode["SlideToLeftAndFadeOut"] = 7] = "SlideToLeftAndFadeOut";
    /**
     * The cells slide to the right and fade out.
     */
    ColumnHidingAnimationMode[ColumnHidingAnimationMode["SlideToRightAndFadeOut"] = 8] = "SlideToRightAndFadeOut";
    /**
     * The cells slide to the top and fade out.
     */
    ColumnHidingAnimationMode[ColumnHidingAnimationMode["SlideToTopAndFadeOut"] = 9] = "SlideToTopAndFadeOut";
    /**
     * The cells slide to the bottom and fade out.
     */
    ColumnHidingAnimationMode[ColumnHidingAnimationMode["SlideToBottomAndFadeOut"] = 10] = "SlideToBottomAndFadeOut";
    return ColumnHidingAnimationMode;
})({});
/**
 * @hidden
 */
export var ColumnHidingAnimationMode_$type = /*@__PURE__*/ markEnum('ColumnHidingAnimationMode', 'Auto,0|None,1|SlideToLeft,2|SlideToRight,3|SlideToTop,4|SlideToBottom,5|FadeOut,6|SlideToLeftAndFadeOut,7|SlideToRightAndFadeOut,8|SlideToTopAndFadeOut,9|SlideToBottomAndFadeOut,10');
//# sourceMappingURL=ColumnHidingAnimationMode.js.map
